export function getFlagClass( element, prefix ) {
	prefix += '-';
	const classNames = [ ...element.classList ];

	for ( const name of classNames ) {
		if ( name.indexOf( prefix ) === 0 ) {
			return name.substr( prefix.length );
		}
	}

	return null;
}

export function setFlagClass( element, prefix, value ) {
	prefix += '-';
	const classNames = [ ...element.classList ];

	classNames.forEach( className => {
		if ( className.indexOf( prefix ) === 0 ) {
			element.classList.remove( className );
		}
	} );

	if ( value ) {
		element.classList.add( `${ prefix }${ value }` );
	}
}
